(function () {
  const root = document.getElementById('ProductSection');
  const form = document.getElementById('product-form');
  if (!root || !form) return;

  const shell = root.querySelector('.product-single__color-variants-shell');
  const source = root.querySelector('.product-single__color-variants');
  if (!shell || !source) return;

  const scrollRow = shell.querySelector('.product-single__scroll-row');
  const radioSelector = '[name="product-single__color-variant-input"]';
  const hiddenSelect = form.querySelector('[id^="ProductSelect-"]');

  let selectorRoot = null;
  let flavorButtons = [];
  let formatButtons = [];

  const normalize = (value) =>
    String(value || '')
      .replace(/\*/g, '')
      .trim()
      .replace(/\s+/g, ' ');

  const getFlavorIcon = (flavor) => {
    const normalized = normalize(flavor).toLowerCase();
    const iconMap = {
      variety: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/557c442187a29d46c7d7094ed9d5af1113b73b.png?v=1786038299',
      'cran apple': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_crane_apple_1.png?v=1787087014',
      'crane apple': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_crane_apple_1.png?v=1787087014',
      grape: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_grape_1.png?v=1787087092',
      'strawberry lemonade': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/3e716ce3458642a862f7a46b25cacedb30d6f7c8.png?v=1786038299',
      grapefruit: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/366950bd132ccce3929fd9ce8eba0c3b4349e688.png?v=1786038299',
      'iced tea lemonade': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_iced_tea_1.png?v=1787087230',
      'ice tea lemonade': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_iced_tea_1.png?v=1787087230',
      mojito: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_mojito_3.png?v=1787087302',
      orange: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Orange_1.png?v=1787087302',
      chocolate: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_chocolate_2_1.png?v=1787087302',
      vanilla: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_vanilla.png?v=1787773516',
      unflavored: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_unflavored_1.png?v=1787087302',
      'passionfruit orange guava': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/baeaafb2efb198978d40eb22bbf20ece43863926.png?v=1786038298',
      passionfruit: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/baeaafb2efb198978d40eb22bbf20ece43863926.png?v=1786038298',
      'watermelon lime': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/9e1d8c780f1afff4d40447f2dff307633a421ff8.png?v=1786038296',
      'pina colada': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/7bb46c9360f7d3f168c27b268348b2291ab95775.png?v=1786038298',
      'piña colada': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/7bb46c9360f7d3f168c27b268348b2291ab95775.png?v=1786038298',
      'mixed berry': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/a4a4cf09471943bcbe749668f24aa43cf3315880.png?v=1786038299',
      'lemon lime': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/5860f252f7576e1181bfc7914f2d3bbaf5bafbd7.png?v=1786038298',
      mango: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/8d5f721095c97abf2a47e3d20166b8c48e553afd.png?v=1786038298'
    };
    return iconMap[normalized] || '';
  };

  const getFlavorColor = (flavor) => {
    const normalized = normalize(flavor).toLowerCase();
    const colorMap = {
      variety: '#009bc0',
      'strawberry lemonade': '#cf2610',
      grapefruit: '#ed8479',
      'iced tea lemonade': '#bb7c3c',
      'ice tea lemonade': '#bb7c3c',
      'passionfruit orange guava': '#7e4465',
      passionfruit: '#7e4465',
      'watermelon lime': '#998f55',
      'pina colada': '#d6bc74',
      'piña colada': '#d6bc74',
      'mixed berry': '#9b4d5c',
      'lemon lime': '#88be67',
      mango: '#c1b766'
    };
    return colorMap[normalized] || '#bfbfbf';
  };

  const getVariantTitle = (input) => {
    const rawTitle = input ? (input.dataset.option1 || input.dataset.variantTitle || input.value || '') : '';
    return normalize(String(rawTitle).split(' - ')[0].split(' / ')[0]);
  };

  const getVariantSize = (input) => {
    let rawSize = input ? (input.dataset.option2 || input.dataset.variantServings || '') : '';
    const title = input ? (input.dataset.variantTitle || input.value || '') : '';
    const titleParts = String(title).split(' / ');
    if (!rawSize && titleParts.length > 1) {
      rawSize = titleParts[1];
    }
    return normalize(rawSize);
  };

  const isSizeValue = (value) => {
    return /serv|scoop|stick|pouch|bag|jar|capsule|count|\b(?:oz|lb|g|ct)\b/i.test(normalize(value));
  };

  const getVariantMeta = (input) => {
    if (!input) return null;
    const option1 = normalize(input.dataset.option1 || '');
    const option2 = normalize(input.dataset.option2 || '');
    const rootsOrder = isSizeValue(option1) && !isSizeValue(option2);
    const flavor = rootsOrder ? option2 : getVariantTitle(input);
    const size = rootsOrder ? option1 : getVariantSize(input);
    return {
      input,
      id: input.dataset.variantId || input.value || '',
      title: size || flavor,
      flavor,
      size,
      available: input.dataset.variantAvailable !== 'false',
      imageUrl: input.dataset.variantImageUrl || '',
      servings: input.dataset.variantServings || '',
      flavorIcon: input.dataset.variantFlavorIcon || ''
    };
  };

  const getVariantInputById = (variantId) => {
    if (!variantId) return null;
    return form.querySelector(
      '[name="product-single__color-variant-input"][data-variant-id="' + variantId + '"]'
    );
  };

  const getVariantSelect = () => hiddenSelect || form.querySelector('[id^="ProductSelect-"]');

  const getSelectedInput = () => {
    const select = getVariantSelect();
    if (select && select.value) {
      const byId = getVariantInputById(select.value);
      if (byId) return byId;
    }
    return form.querySelector(radioSelector + ':checked');
  };

  const setActiveState = (buttons, activeButton, className) => {
    buttons.forEach((button) => {
      button.classList.toggle(className, button === activeButton);
    });
  };

  const showFormatsForFlavor = (flavor) => {
    const normalized = normalize(flavor).toLowerCase();
    formatButtons.forEach((button) => {
      const buttonFlavor = normalize(button.dataset.variantFlavor || '').toLowerCase();
      const match = buttonFlavor === normalized;
      button.hidden = !match;
      button.classList.toggle('featured-product__variant-btn--hidden', !match);
    });
  };

  const getFormatButtonForFlavor = (flavor, preferredSize) => {
    const normalizedFlavor = normalize(flavor).toLowerCase();
    const normalizedSize = normalize(preferredSize).toLowerCase();
    const matches = formatButtons.filter((button) => {
      return normalize(button.dataset.variantFlavor || '').toLowerCase() === normalizedFlavor;
    });
    if (!matches.length) return null;
    if (normalizedSize) {
      const exact = matches.find((button) => {
        return normalize(button.dataset.variantSize || '').toLowerCase() === normalizedSize;
      });
      if (exact) return exact;
    }
    return matches.find((button) => button.dataset.variantAvailable !== 'false') || matches[0];
  };

  const syncFromInput = (input) => {
    if (!selectorRoot) return;
    const meta = getVariantMeta(input || getSelectedInput());
    if (!meta) return;
    const activeFlavorButton =
      flavorButtons.find((button) => {
        return normalize(button.dataset.featuredFlavor || '').toLowerCase() === meta.flavor.toLowerCase();
      }) || null;
    setActiveState(flavorButtons, activeFlavorButton, 'featured-product__flavor-btn--active');
    showFormatsForFlavor(meta.flavor);
    const activeFormatButton =
      formatButtons.find((button) => String(button.dataset.variantId || '') === String(meta.id || '')) ||
      getFormatButtonForFlavor(meta.flavor, meta.size);
    setActiveState(formatButtons, activeFormatButton, 'featured-product__variant-btn--active');
  };

  const activateVariantById = (variantId) => {
    if (!variantId) return;
    const select = getVariantSelect();
    const input = getVariantInputById(variantId);
    if (select) {
      if (select.value !== String(variantId)) {
        select.value = String(variantId);
      }
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncFromInput(input || getSelectedInput());
  };

  const build = () => {
    if (selectorRoot) return;
    const inputs = Array.prototype.slice.call(source.querySelectorAll(radioSelector));
    if (!inputs.length) return;

    source.hidden = true;
    source.style.display = 'none';
    if (scrollRow) {
      scrollRow.hidden = true;
      scrollRow.style.display = 'none';
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'featured-product__hydration-selector';

    const defaultInput = getSelectedInput() || inputs[0];
    const defaultMeta = getVariantMeta(defaultInput) || getVariantMeta(inputs[0]);
    const seenFlavors = {};
    const seenFormats = {};

    const flavorGroup = document.createElement('div');
    flavorGroup.className = 'featured-product__variant-group';
    const flavorLabel = document.createElement('span');
    flavorLabel.className = 'featured-product__variant-label';
    flavorLabel.textContent = 'Flavor';
    const flavorGrid = document.createElement('div');
    flavorGrid.className = 'featured-product__flavor-grid';

    inputs.forEach((input) => {
      const meta = getVariantMeta(input);
      if (!meta || !meta.flavor) return;
      const key = meta.flavor.toLowerCase();
      if (seenFlavors[key]) return;
      seenFlavors[key] = true;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'featured-product__flavor-btn';
      button.dataset.featuredFlavorBtn = '';
      button.dataset.featuredFlavor = meta.flavor;
      button.style.setProperty('--flavor-color', getFlavorColor(meta.flavor));
      if (defaultMeta && meta.flavor.toLowerCase() === defaultMeta.flavor.toLowerCase()) {
        button.classList.add('featured-product__flavor-btn--active');
      }

      const media = document.createElement('span');
      media.className = 'featured-product__flavor-media';
      media.setAttribute('aria-hidden', 'true');
      const icon = meta.flavorIcon || getFlavorIcon(meta.flavor);
      if (icon) {
        const img = document.createElement('img');
        img.src = icon;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 24;
        img.height = 24;
        img.style.width = '24px';
        img.style.height = '24px';
        img.style.maxWidth = '24px';
        img.style.maxHeight = '24px';
        media.appendChild(img);
      } else {
        const dot = document.createElement('span');
        dot.className = 'featured-product__flavor-dot';
        media.appendChild(dot);
      }

      const text = document.createElement('span');
      text.className = 'featured-product__flavor-text';
      text.textContent = meta.flavor;

      const check = document.createElement('span');
      check.className = 'featured-product__flavor-check';
      check.setAttribute('aria-hidden', 'true');
      const checkImg = document.createElement('img');
      checkImg.src = 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Check_icon_ba1f8d8a-50e7-4187-bc70-ba563c3858bd.png?v=1786038278';
      checkImg.alt = '';
      checkImg.loading = 'lazy';
      checkImg.width = 16;
      checkImg.height = 16;
      checkImg.style.width = '16px';
      checkImg.style.height = '16px';
      checkImg.style.maxWidth = '16px';
      checkImg.style.maxHeight = '16px';
      check.appendChild(checkImg);

      button.appendChild(media);
      button.appendChild(text);
      button.appendChild(check);
      button.addEventListener('click', () => {
        const preferredSize = (getVariantMeta(getSelectedInput()) || defaultMeta || {}).size;
        const nextButton = getFormatButtonForFlavor(meta.flavor, preferredSize);
        showFormatsForFlavor(meta.flavor);
        setActiveState(flavorButtons, button, 'featured-product__flavor-btn--active');
        if (nextButton) {
          activateVariantById(nextButton.dataset.variantId);
        }
      });
      flavorGrid.appendChild(button);
    });

    flavorGroup.appendChild(flavorLabel);
    flavorGroup.appendChild(flavorGrid);

    const formatGroup = document.createElement('div');
    formatGroup.className = 'featured-product__variant-group featured-product__variant-group--format';
    const formatLabel = document.createElement('span');
    formatLabel.className = 'featured-product__variant-label';
    formatLabel.textContent = 'Size';
    const formatGrid = document.createElement('div');
    formatGrid.className = 'featured-product__format-grid';

    inputs.forEach((input) => {
      const meta = getVariantMeta(input);
      if (!meta || !meta.flavor || !meta.size) return;
      const key = meta.flavor.toLowerCase() + '::' + meta.size.toLowerCase();
      if (seenFormats[key]) return;
      seenFormats[key] = true;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'featured-product__variant-btn';
      button.dataset.featuredFormatBtn = '';
      button.dataset.variantId = meta.id;
      button.dataset.variantTitle = meta.title;
      button.dataset.variantFlavor = meta.flavor;
      button.dataset.variantSize = meta.size;
      button.dataset.variantAvailable = input.dataset.variantAvailable || 'true';
      button.dataset.variantImage = input.dataset.variantImageUrl || '';
      if (defaultMeta && meta.flavor.toLowerCase() !== defaultMeta.flavor.toLowerCase()) {
        button.hidden = true;
        button.classList.add('featured-product__variant-btn--hidden');
      }
      if (defaultMeta && meta.id === defaultMeta.id) {
        button.classList.add('featured-product__variant-btn--active');
      }

      const media = document.createElement('span');
      media.className = 'featured-product__variant-media';
      media.setAttribute('aria-hidden', 'true');
      if (meta.imageUrl) {
        const img = document.createElement('img');
        img.src = meta.imageUrl;
        img.alt = meta.title;
        img.loading = 'lazy';
        img.width = 48;
        img.height = 48;
        img.style.width = '48px';
        img.style.height = '48px';
        img.style.maxWidth = '48px';
        img.style.maxHeight = '48px';
        media.appendChild(img);
      }

      const copy = document.createElement('span');
      copy.className = 'featured-product__variant-copy';
      const title = document.createElement('span');
      title.className = 'featured-product__variant-title';
      title.textContent = meta.flavor;
      const subtitle = document.createElement('span');
      subtitle.className = 'featured-product__variant-subtitle';
      const servingsLabel = normalize(meta.servings);
      subtitle.textContent = servingsLabel
        ? /serv/i.test(servingsLabel)
          ? servingsLabel
          : servingsLabel + ' servings'
        : meta.size || '';

      copy.appendChild(title);
      if (subtitle.textContent) {
        copy.appendChild(subtitle);
      }

      button.appendChild(media);
      button.appendChild(copy);
      button.addEventListener('click', () => activateVariantById(meta.id));
      formatGrid.appendChild(button);
    });

    formatGroup.appendChild(formatLabel);
    formatGroup.appendChild(formatGrid);

    wrapper.appendChild(flavorGroup);
    wrapper.appendChild(formatGroup);
    shell.appendChild(wrapper);

    selectorRoot = wrapper;
    flavorButtons = Array.prototype.slice.call(wrapper.querySelectorAll('[data-featured-flavor-btn]'));
    formatButtons = Array.prototype.slice.call(wrapper.querySelectorAll('[data-featured-format-btn]'));
    syncFromInput(defaultInput);
  };

  const handleChange = (event) => {
    if (!event.target) return;
    if (
      event.target.matches(radioSelector) ||
      event.target.matches('[id^="ProductSelect-"]') ||
      event.target.matches('.single-option-selector')
    ) {
      syncFromInput(getSelectedInput());
    }
  };

  const init = () => {
    build();
    syncFromInput(getSelectedInput());
    document.addEventListener('change', handleChange);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

if (window.location.hash === '#pdp-customer-reviews') {
  window.addEventListener('load', () => {
    window.setTimeout(() => {
      document.getElementById('pdp-customer-reviews')?.scrollIntoView({ block: 'start' });
    }, 1000);
  });
}
